// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","left":"Header_left__C-xwl","menu":"Header_menu__ItUnw","right":"Header_right__pLR75"};